import { render, staticRenderFns } from "./RelatorioCotasClienteListFiltroModalItem.vue?vue&type=template&id=d22fa042"
import script from "./RelatorioCotasClienteListFiltroModalItem.vue?vue&type=script&lang=js"
export * from "./RelatorioCotasClienteListFiltroModalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports